// assets.js
export const logo = require('../../assets/logo.png');
export const logoWhite = require('../../assets/logoWhite.png');

export const light = require('../../assets/light.png');
export const watch = require('../../assets/watch.png');
export const clock = require('../../assets/clock.png');
export const binoculars = require('../../assets/binoculars.png');
export const team = require('../../assets/team.png');

export const rapost = require('../../assets/rapost.png');
export const tanzart = require('../../assets/tanzart.png');
export const swilla = require('../../assets/swilla.png');
export const yatch = require('../../assets/yatch.png');
export const ngnantranga = require('../../assets/ngnantranga2.png');
export const sanecka = require('../../assets/sanecka3.png');

export const microsoft = require('../../assets/microsoft.webp');
export const apple = require('../../assets/apple.png');
export const amazon = require('../../assets/amazon.png');
export const hp = require('../../assets/hp.png');
export const bluehost = require('../../assets/bluehost.png');
export const google = require('../../assets/google.png');
export const namecheap = require('../../assets/namecheap.png');


export const school = require('../../assets/school1.png');
export const fuel = require('../../assets/fuel1.png');


export const equalizer = require('../../assets/equalizer.png');
export const microphone1 = require('../../assets/microphone1.jpg');
export const microphone2 = require('../../assets/microphone2.jpg');
export const microphone3 = require('../../assets/microphone3.jpg');
export const audio = require('../../assets/audio.jpg');
export const guitar = require('../../assets/guitar.jpg');
export const guitar2 = require('../../assets/guitar2.jpg');


export const recordPlayer = require('../../assets/recordPlayer.jpg');
export const concert = require('../../assets/concert.jpg');

export const amazonMusic = require('../../assets/socials/amazonMusic.svg');
export const appleMusic = require('../../assets/socials/appleMusic.svg');
export const audiomack = require('../../assets/socials/audiomack.svg');
export const boomplay = require('../../assets/socials/boomplay.svg');
export const deezer = require('../../assets/socials/deezer.svg');
export const spotify = require('../../assets/socials/spotify.svg');
export const youtube = require('../../assets/socials/youtube.svg');
export const youtubeMusic = require('../../assets/socials/youtubeMusic.svg');
// export const svg = require('../../assets/socials/svg.svg');

// export const logo = require('../../assets/logo.png');
